import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=87e776a6&scoped=true"
import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=87e776a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e776a6",
  null
  
)

export default component.exports